import { NavigateFunction } from "react-router-dom"
import { LayoutStateInterface } from "../../GlobalStates/LayoutState"
import { LoginStateInterface } from "../../GlobalStates/LoginState"
import { TipoUsuario } from "../../ImportBackend/Interfaces/RolesInterfaces"

export class ClsLogout {

  public efetuarLogout (
    setLoginState: React.Dispatch<React.SetStateAction<LoginStateInterface>>,
    setLayoutState: React.Dispatch<React.SetStateAction<LayoutStateInterface>>,
    navigate: NavigateFunction
  ) {

    localStorage.removeItem( 'token' )

    // Reset LoginState
    setLoginState( {
      logado: false,
      tipo: TipoUsuario.NAO_LOGADO,
      idUsuario: 0,
      permissoes: [],
      token: '',
      nome: ''
    } )

    // Reset LauoutState
    setLayoutState( {
      descricaoUnidadeAtual: '',
      opcaoNavegacaoInferior: -1,
      exibirMenu: false,
      opcoesMenu: []
    } )

    navigate( '/' )
  }
}